module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_02-be56dd1843efc1bc5981c780123ee68f.jpg";